export const fieldLabels: Record<string, string> = {
  // General Information
  licenseName: "License Name",
  licenseAddress: "License Address",
  PAN: "PAN",
  GST: "GST",
  stateCode: "State Code",
  CIN: "CIN",
  GSTStateCode: "GST State Code",

  // Invoice Details
  invoiceNo: "Invoice No.",
  invoiceDate: "Invoice Date",
  piNo: "PI No.",
  dcNo: "DC No.",

  // Permit Details
  exportPermitNoAndDate: "Export Permit No. & Date",
  importPermitNoAndDate: "Import Permit No. & Date",
  customerExecRegNo: "Customer Exec. Reg No.",
  customerExecLeafNo: "Customer Exec. Leaf No.",

  // Transport Details
  transporter: "Transporter",
  transporterPermitNo: "Transporter Permit No.",
  vehicleNo: "Vehicle No.",
};
